module.exports = __webpack_public_path__ + "img/search-icon-on.b858ecfa.svg";